import { useMemo } from "react";

export const EVENT_TYPES = [
  { value: "practice",    label: "Practice",    accent: "border-[#00E5FF]/30 bg-[#00E5FF]/10 text-[#00E5FF]" },
  { value: "performance", label: "Performance", accent: "border-amber-400/30 bg-amber-400/10 text-amber-300" },
  { value: "competition", label: "Competition", accent: "border-violet-400/30 bg-violet-400/10 text-violet-300" },
  { value: "social",      label: "Social",      accent: "border-emerald-400/30 bg-emerald-400/10 text-emerald-300" },
  { value: "other",       label: "Other",       accent: "border-white/15 bg-white/5 text-white/70" },
];

export function getEventTypeMeta(v) {
  return EVENT_TYPES.find((t) => t.value === v) || EVENT_TYPES[EVENT_TYPES.length - 1];
}

export function formatEventDate(iso, all_day = false) {
  if (!iso) return { month: "TBD", day: "?", weekday: "", time: "" };
  try {
    const d = new Date(iso);
    return {
      month: d.toLocaleDateString(undefined, { month: "short" }).toUpperCase(),
      day: d.getDate(),
      weekday: d.toLocaleDateString(undefined, { weekday: "short" }),
      time: all_day ? "All day" : d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }),
      iso: d.toISOString(),
    };
  } catch {
    return { month: "—", day: "—", weekday: "", time: "" };
  }
}

export function formatEventRange(starts_at, ends_at, all_day) {
  const s = starts_at ? new Date(starts_at) : null;
  const e = ends_at ? new Date(ends_at) : null;
  if (!s) return "";
  if (all_day) return s.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
  const fmt = (d) => d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  if (!e) return `${s.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" })} · ${fmt(s)}`;
  const sameDay = e.toDateString() === s.toDateString();
  if (sameDay) {
    return `${s.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" })} · ${fmt(s)} – ${fmt(e)}`;
  }
  return `${s.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })} → ${e.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}`;
}

// Group events by "Month YYYY" key, preserving order.
export function useGroupedEvents(events) {
  return useMemo(() => {
    const groups = [];
    for (const ev of events || []) {
      const d = ev.starts_at ? new Date(ev.starts_at) : null;
      const label = d
        ? d.toLocaleDateString(undefined, { month: "long", year: "numeric" })
        : "Date TBD";
      const last = groups[groups.length - 1];
      if (last && last.label === label) last.items.push(ev);
      else groups.push({ label, items: [ev] });
    }
    return groups;
  }, [events]);
}
